export class FormaPago {

    public intId?:number;
    public strNombre?:string;
    public strActivo?:string;

}
